class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.sideCart = document.querySelector(".cart-up-rec");
    this.drawerInner = this.querySelector(".drawer__inner");
    this.observer = null; // Store observer instance

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.observeCartChanges(); // Start observing class changes
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);

    // Open main cart
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);

        // Open side cart **ONLY IF** main cart is open and not empty
        setTimeout(() => {
          if (!this.classList.contains("is-empty") && this.classList.contains("active")) {
            this.sideCart.style.visibility = "visible";
            this.sideCart.style.opacity = "1";
            this.sideCart.classList.add("active");
          }
        }, 200); // Adjust delay as needed
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    // Disable observer before making changes
    if (this.observer) this.observer.disconnect();

    // First, slide the side cart out
    this.sideCart.classList.remove("active");

    // Wait for side cart animation to finish before closing the main cart
    setTimeout(() => {
      this.sideCart.style.visibility = "hidden";
      this.sideCart.style.opacity = "0";
      this.classList.remove("active");
      removeTrapFocus(this.activeElement);
      document.body.classList.remove("overflow-hidden");

      // Re-enable observer after cart has fully closed
      this.observeCartChanges();
    }, 300); // Adjust delay to match side cart transition duration
  }

  observeCartChanges() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          const isEmpty = this.classList.contains("is-empty");

          // Prevent reopening when cart is closed
          if (!this.classList.contains("active")) return;

          if (isEmpty) {
            this.sideCart.classList.remove("active");
            setTimeout(() => {
              this.sideCart.style.visibility = "hidden";
              this.sideCart.style.opacity = "0";
            }, 300);
          } else {
            setTimeout(() => {
              if (this.classList.contains("active")) {
                this.sideCart.style.visibility = "visible";
                this.sideCart.style.opacity = "1";
                this.sideCart.classList.add("active");
              }
            }, 200);
          }
        }
      });
    });

    // Start observing class attribute changes on the cart drawer
    this.observer.observe(this, { attributes: true, attributeFilter: ["class"] });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });


      setTimeout(() => {
        this.sideCart = document.querySelector(".cart-up-rec");
        this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
        this.open();
      }, 200);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
